import { IsIn, IsNotEmpty } from 'class-validator';
import {
  SUPPORTED_LANGUAGES,
  SupportedCurrency,
  SupportedLanguage,
  SupportedTimezone,
} from '../../attributes';
import { CURRENCY_OPTIONS, TIMEZONE_OPTIONS } from '../../data';

export class UserInternationalizationDto {
  @IsIn(TIMEZONE_OPTIONS.map((t) => t.id))
  @IsNotEmpty()
  timezone!: SupportedTimezone;

  @IsIn(SUPPORTED_LANGUAGES)
  @IsNotEmpty()
  language!: SupportedLanguage;

  @IsIn(CURRENCY_OPTIONS.map((t) => t.code))
  @IsNotEmpty()
  currency!: SupportedCurrency;
}
